import {ClientDocumentSortBy, SortOrder} from "./domain";
import {reduceRelayPaginationAction, RelayPaginationActionPayload, RelayPaginationState} from "../pagination";

export type ClientDocumentListAction =
    | { type: 'SET_SORT_BY'; sortBy: ClientDocumentSortBy }
    | { type: 'SET_DOCUMENT_TYPE_FILTER'; documentTypeFilter: string }
    | { type: 'SET_SEARCH'; search: string }
    | RelayPaginationActionPayload;


export interface ClientDocumentListState {
    sortBy: ClientDocumentSortBy;
    pagination: RelayPaginationState;
    documentTypeFilter: string;
    searchFilter: string;
}


export function initState(): ClientDocumentListState {
    return {
        documentTypeFilter: "",
        pagination: new RelayPaginationState('0', 8),
        searchFilter: "",
        sortBy: {
            column: "documentName",
            order: SortOrder.DESC
        }
    };
}

export function clientDocumentListReducer(
    state: ClientDocumentListState,
    action: ClientDocumentListAction
): ClientDocumentListState {
    switch (action.type) {
        case 'RELAY_PAGINATION_ACTION':
            return {
                ...state,
                pagination: reduceRelayPaginationAction(state.pagination, action)
            };
        case 'SET_DOCUMENT_TYPE_FILTER':
            return {
                ...state,
                documentTypeFilter: action.documentTypeFilter,
                pagination: new RelayPaginationState('0', 8),
            };
        case 'SET_SEARCH':
            return {
                ...state,
                searchFilter: action.search,
                pagination: new RelayPaginationState('0', 8),
            };
        case 'SET_SORT_BY':
            return {
                ...state,
                sortBy: action.sortBy
            };
        default:
            return state;
    }
}
